import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Terminal from './components/Terminal';
import NumberSorting from './components/NumberSorting';
import BootSequence from './components/BootSequence';
import LumonLogo from './components/LumonLogo';
import FileSelection from './components/FileSelection';

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  background-color: #000;
  padding: 20px;
  position: relative;
  overflow: hidden;
`;

const ScanLines = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 50%,
    rgba(0, 0, 0, 0.25) 50%
  );
  background-size: 100% 4px;
  z-index: 10;
  pointer-events: none;
  opacity: 0.3;
`;

const CRT = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  box-shadow: 0 0 10px 5px rgba(0, 255, 0, 0.1) inset;
  pointer-events: none;
  z-index: 11;
`;

const StatusBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 2px solid #00ff00;
  font-size: 1.2rem;
  z-index: 1;
`;

const App = () => {
  const [currentScreen, setCurrentScreen] = useState('boot');
  const [employeeName, setEmployeeName] = useState('');
  const [employeeId, setEmployeeId] = useState('');
  const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString());
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentScreen('login');
    }, 5000);

    const clockInterval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => {
      clearTimeout(timer);
      clearInterval(clockInterval);
    };
  }, []);

  const handleLogin = (name, id) => {
    setEmployeeName(name);
    setEmployeeId(id);
    setCurrentScreen('fileSelection');
  };

  const handleFileSelect = (file) => {
    setSelectedFile(file);
    setCurrentScreen('numberSorting');
  };

  const handleBackToFiles = () => {
    setSelectedFile(null);
    setCurrentScreen('fileSelection');
  };

  const handleLogout = () => {
    setEmployeeName('');
    setEmployeeId('');
    setSelectedFile(null);
    setCurrentScreen('login');
  };

  const renderScreen = () => {
    switch (currentScreen) {
      case 'boot':
        return <BootSequence />;
      case 'login':
        return <Terminal onLogin={handleLogin} />;
      case 'fileSelection':
        return (
          <>
            <StatusBar>
              <div>LUMON INDUSTRIES - MDR DIVISION</div>
              <div>EMPLOYEE: {employeeName} | ID: {employeeId}</div>
              <div>{currentTime}</div>
            </StatusBar>
            <FileSelection onFileSelect={handleFileSelect} onLogout={handleLogout} />
          </>
        );
      case 'numberSorting':
        return (
          <>
            <StatusBar>
              <div>LUMON INDUSTRIES - MDR DIVISION</div>
              <div>FILE: {selectedFile?.name} | EMPLOYEE: {employeeName}</div>
              <div>{currentTime}</div>
            </StatusBar>
            <NumberSorting 
              onBackToFiles={handleBackToFiles} 
              onLogout={handleLogout}
              file={selectedFile}
            />
          </>
        );
      default:
        return <BootSequence />;
    }
  };

  return (
    <AppContainer>
      <LumonLogo />
      {renderScreen()}
      <ScanLines />
      <CRT />
    </AppContainer>
  );
};

export default App;
